module.exports = __webpack_public_path__ + "static/media/single-folded-content.aa9281b2.svg";